// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"730":"c77e19e19d31878a","920":"72a70d4ac6900218","933":"b7b734a6cf8b790c","975":"980e0a2c89e9d839"}[chunkId] + ".js";
};